/** @class {Action} */
import Action from '../flux/Action';

/** @type {Action} */
export default new Action({
  // start and end zooming
  START: 0,
  END:   1,

  // on mouse devices, disable clicks whilst panning
  CLICK_DISABLE: 2,
  CLICK_RESET:   3,

  // different zoom actions
  ZOOM:  10,
  PINCH: 11,
  MOVE:  12,
  RESET: 13,

  // fit block in view
  FIT_IN_VIEW: 20,

  // enable/disable scroll to zoom
  SCROLL_TO_ZOOM: 30,

  REGISTER:    100,
  DE_REGISTER: 101
});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/actions/zoomer.js